// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContainer {
  display: flex;
  margin: 0;
  padding: 0;
  flex-direction: column;
  background: var(--ion-white-primary);
  --background: var(--ion-white-primary);
}
.modalContainer .item {
  background: transparent;
  border-radius: 0px;
  padding: 3vw;
  width: 94vw;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modalContainer .itemImg {
  width: 100vw;
  height: 100%;
  aspect-ratio: 2.5/1;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
  background: white;
  overflow: hidden;
  box-shadow: var(--shadow-glass-anim-end);
}
.modalContainer .itemTitle {
  font-size: 20px;
  font-weight: 600;
  margin-top: 10px;
  text-transform: capitalize;
  text-decoration: underline;
}
.modalContainer .itemDesc {
  font-size: 14px;
  font-weight: 400;
  margin-top: 10px;
}

.modalFooter {
  display: flex;
  margin: 0;
  padding: 2vw;
  flex-direction: row-reverse;
  gap: 2vw;
  align-items: center;
  justify-content: space-between;
  background: var(--ion-white-primary);
  --background: var(--ion-white-primary);
}

app-button {
  height: 7vw;
  max-width: 7vw;
  min-width: 7vw;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/general-modal/general-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,oCAAA;EACA,sCAAA;AACF;AACE;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAEE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;EACA,oCAAA;EACA,sCAAA;AAHF;;AAMA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAHF","sourcesContent":[".modalContainer {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  flex-direction: column;\n  background: var(--ion-white-primary);\n  --background: var(--ion-white-primary);\n\n  .item {\n    background: transparent;\n    border-radius: 0px;\n    padding: 3vw;\n    width: 94vw;\n    text-align: center;\n    cursor: pointer;\n    transition: transform 0.2s;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .itemImg {\n    width: 100vw;\n    height: 100%;\n    aspect-ratio: 2.5 / 1;\n    object-fit: cover;\n    object-position: center;\n    border-radius: 12px;\n    background: white;\n    overflow: hidden;\n    box-shadow: var(--shadow-glass-anim-end);\n  }\n\n  .itemTitle {\n    font-size: 20px;\n    font-weight: 600;\n    margin-top: 10px;\n    text-transform: capitalize;\n    text-decoration: underline;\n  }\n\n  .itemDesc {\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: 10px;\n  }\n}\n\n.modalFooter {\n  display: flex;\n  margin: 0;\n  padding: 2vw;\n  flex-direction: row-reverse;\n  gap: 2vw;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--ion-white-primary);\n  --background: var(--ion-white-primary);\n}\n\napp-button {\n  height: 7vw;\n  max-width: 7vw;\n  min-width: 7vw;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
